import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import '../../assets/css/AboutUs.css';
import '../../assets/css/Packages.css'
import '../../assets/css/Contact.css'
import '../../assets/css/Checkout.css'
import '../../assets/css/Thankyou.css';

const Thankyou = () => {
    let navigate = useNavigate();
    return (
        <div className='checkout Thankyou'>
            <section className='checkout-container'>
                <Header />
                <div className='inner-container'>
                    <div className='thankyou-container'>
                        <h2 className='thank-title'>Thank You!</h2>
                        <p className='thank-sub'>For buying our membership</p>
                        <p className='thank-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                        <div className='btn-container'>
                            <Link to='/' className='btn cont-btn'>Continue</Link>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Thankyou;
